"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _commonHeading = require("@mmc/common-heading");
var _dealerLocator = _interopRequireDefault(require("../styles/dealer-locator.css"));
var _dealerDetails = _interopRequireDefault(require("./dealer-details"));
var _dealerList = _interopRequireDefault(require("./dealer-list"));
var _searchDealershipsGetLocationButton = _interopRequireDefault(require("./search-dealerships/search-dealerships-get-location-button"));
var _searchDealershipsListToggle = _interopRequireDefault(require("./search-dealerships/search-dealerships-list-toggle"));
var _searchDealershipsSelectFilter = _interopRequireDefault(require("./search-dealerships/search-dealerships-select-filter"));
var _searchDealershipsStatusLabel = _interopRequireDefault(require("./search-dealerships/search-dealerships-status-label"));
var _types = _interopRequireDefault(require("./types"));
var _mapNew = _interopRequireDefault(require("./map-new"));
var _commonSetLocation = require("@mmc/common-set-location");
var _commonLibs = require("@mmc/common-libs");
var _clsx3 = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SearchDealerships = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(SearchDealerships, _React$Component);
  SearchDealerships.addEventToDataLayer = function addEventToDataLayer(e) {
    if (typeof window !== 'undefined' && window.dataLayer) {
      var event = _objectSpread({}, e);
      event.searchLocation = typeof window.document !== 'undefined' && window.document.title;
      window.dataLayer.push(event);
    }
  };
  SearchDealerships.getLocalityFromGetMyLocation = function getLocalityFromGetMyLocation(_results) {
    var location;
    _results.forEach(function (result, index) {
      if (result.types[0] === 'locality') {
        location = _results[index].formatted_address;
      }
    });
    return location;
  };
  SearchDealerships.getStateCodeFromGooglePlaceResults = function getStateCodeFromGooglePlaceResults(results) {
    var _results$0$address_co;
    return (_results$0$address_co = results[0].address_components.find(function (addressComponent) {
      return addressComponent.types.some(function (type) {
        return type === 'administrative_area_level_1';
      });
    })) == null ? void 0 : _results$0$address_co.short_name;
  };
  function SearchDealerships(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.retryGeocodeWithLatlng = function (lat, lng) {
      var geocoder = new window.google.maps.Geocoder();
      var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      var lookup = {
        latLng: latLng
      };
      geocoder.geocode(lookup, function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
          (0, _commonSetLocation.setUpdatedPostalCodeInCachedLocation)(postalCode);
        }
      });
    };
    _this.state = {
      searchValue: props.searchValue || '',
      searchDisplayValue: '',
      showList: false,
      geoCoderError: false,
      searchButtonDisabled: true
      /* getLocationUsed: false, */
    };
    _this.mapRef = null;
    _this.clearDealers = _this.clearDealers.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getLocation = _this.getLocation.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onInputChange = _this.onInputChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.sendForm = _this.sendForm.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showResetOrSearchIcon = _this.showResetOrSearchIcon.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showList = _this.showList.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBackButton = _this.handleBackButton.bind((0, _assertThisInitialized2["default"])(_this));
    _this.searchDealersForm = /*#__PURE__*/(0, _react.createRef)();
    _this.searchDealersInputField = /*#__PURE__*/(0, _react.createRef)();
    _this.searchDealersSubmitButton = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }
  var _proto = SearchDealerships.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.showList();
    this.showResetOrSearchIcon();
    this.searchDealersSubmitButton.current.disabled = true;
    var _this$props = this.props,
      onSearchStart = _this$props.onSearchStart,
      onSearchEnd = _this$props.onSearchEnd;
    var _getCachedLocation = (0, _commonSetLocation.getCachedLocation)(),
      searchValue = _getCachedLocation.searchValue,
      userLocation = _getCachedLocation.userLocation,
      stateCode = _getCachedLocation.stateCode;
    if (searchValue) {
      onSearchStart();
      this.setState({
        showList: true,
        searchValue: searchValue,
        searchDisplayValue: searchValue
      }, function () {
        var _this2$props = _this2.props,
          updateMapCentre = _this2$props.updateMapCentre,
          updateStateCode = _this2$props.updateStateCode,
          updateUserLocation = _this2$props.updateUserLocation;
        _this2.props.setSearchValue(searchValue);
        updateMapCentre(userLocation);
        updateUserLocation(userLocation);
        updateStateCode(stateCode);
        onSearchEnd();
      });
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
      selectedDealer = _this$props2.selectedDealer,
      scrollToTop = _this$props2.scrollToTop;
    this.showResetOrSearchIcon();
    if (!prevProps.selectedDealer && selectedDealer) {
      scrollToTop();
    }
    if (prevProps.selectedDealer && selectedDealer && prevProps.selectedDealer.id !== selectedDealer.id) {
      scrollToTop();
    }
    if (prevState.searchValue === '' && !prevState.searchButtonDisabled) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        searchButtonDisabled: true
      });
    }
  };
  _proto.handleBackButton = function handleBackButton() {
    var updateSelectedDealer = this.props.updateSelectedDealer;
    return updateSelectedDealer();
  };
  _proto.onInputChange = function onInputChange(event) {
    var setSearchValue = this.props.setSearchValue;
    var searchValue = event.target.value;
    this.setState({
      searchValue: searchValue,
      searchButtonDisabled: false
    }, function () {
      return setSearchValue(searchValue);
    });
  };
  _proto.onPlaceChange = function onPlaceChange(map) {
    this.mapRef = map;
    if (this.searchDealersForm && this.searchDealersForm.current) {
      this.searchDealersForm.current.dispatchEvent(new Event('submit', {
        cancelable: true
      }));
    }
  };
  _proto.setGeoCoder = function setGeoCoder() {
    var _this3 = this;
    var _this$props3 = this.props,
      updateMapCentre = _this$props3.updateMapCentre,
      updateStateCode = _this$props3.updateStateCode,
      updateUserLocation = _this$props3.updateUserLocation,
      onSearchEnd = _this$props3.onSearchEnd,
      toggleGeoCodeError = _this$props3.toggleGeoCodeError,
      resourceType = _this$props3.pageData.resourceType,
      market = _this$props3.market;
    var _this$state = this.state,
      geoCoderError = _this$state.geoCoderError,
      searchValue = _this$state.searchValue;
    var geocoder = new window.google.maps.Geocoder();
    return geocoder.geocode({
      address: searchValue,
      region: market
    }, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var coords = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        var _location = SearchDealerships.getLocalityFromGetMyLocation(results);
        var stateCode = SearchDealerships.getStateCodeFromGooglePlaceResults(results);
        var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
        var city = (0, _commonSetLocation.getCityFromGooglePlaceResults)(results);
        var locationData = {
          searchValue: searchValue,
          userLocation: coords,
          stateCode: stateCode,
          postalCode: postalCode,
          city: city
        };
        _commonLibs.EventEmitter.dispatch('locationChangeEvent', locationData);
        if (!postalCode) {
          _this3.retryGeocodeWithLatlng(coords.lat, coords.lng);
        }
        _this3.setState({
          showList: true,
          geoCoderError: false
        }, function () {
          updateMapCentre(coords);
          updateUserLocation(coords);
          updateStateCode(stateCode);
          SearchDealerships.addEventToDataLayer({
            event: 'location_search',
            component: resourceType,
            searchDisplayValue: _location,
            stateCode: stateCode,
            userLocation: coords
          });
          onSearchEnd();
        });
      } else {
        _this3.setState({
          geoCoderError: true
        }, toggleGeoCodeError(geoCoderError));
      }
    });
  };
  _proto.getLocation = function getLocation(self) {
    // eslint-disable-line
    var input = this.searchDealersInputField.current;
    input.classList.add(_dealerLocator["default"].close);
    var geocoder = new window.google.maps.Geocoder();

    // self.clearDealers();
    //  console.log("clearDealers fired form getLocation");
    var _this$props4 = this.props,
      updateMapCentre = _this$props4.updateMapCentre,
      updateUserLocation = _this$props4.updateUserLocation,
      updateStateCode = _this$props4.updateStateCode,
      toggleGeoCodeError = _this$props4.toggleGeoCodeError,
      isInitialMapLoad = _this$props4.isInitialMapLoad,
      setIsInitialMapLoad = _this$props4.setIsInitialMapLoad,
      resourceType = _this$props4.pageData.resourceType;
    var geoCoderError = this.state.geoCoderError;
    if (navigator.geolocation) {
      if (isInitialMapLoad) setIsInitialMapLoad(false);
      navigator.geolocation.getCurrentPosition(function success(position) {
        var _this4 = this;
        var myLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        geocoder.geocode({
          location: myLocation // this.state.searchValue
        }, function (results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            var _location = SearchDealerships.getLocalityFromGetMyLocation(results);
            var stateCode = SearchDealerships.getStateCodeFromGooglePlaceResults(results);
            return self.setState({
              showList: true,
              searchValue: _location,
              searchDisplayValue: _location /* , getLocationUsed: true */
            }, function () {
              self.props.setSearchValue(_location);
              updateMapCentre(myLocation);
              updateUserLocation(myLocation);
              updateStateCode(stateCode);
              SearchDealerships.addEventToDataLayer({
                event: 'location_search',
                component: resourceType,
                searchDisplayValue: _location,
                stateCode: stateCode,
                userLocation: myLocation
              });
            });
          }
          return _this4.setState({
            geoCoderError: true
          }, toggleGeoCodeError(geoCoderError));
        });

        // return self.setState({ showList: true }, () => {
        //   updateMapCentre(myLocation);
        //   updateUserLocation(myLocation);
        // });
      }, function () {
        return self.setState({
          geoCoderError: true
        }, function () {
          toggleGeoCodeError(geoCoderError);
        });
      }, {
        timeout: 5000 // default value is Infinity, so we set to 5s before error as UI has no loader
      });
    } else {
      return this.setState({
        geoCoderError: true
      }, function () {
        toggleGeoCodeError(geoCoderError);
      });
    }
  };
  _proto.sendData = function sendData(input) {
    var _this5 = this;
    var _this$props5 = this.props,
      setSearchValue = _this$props5.setSearchValue,
      onSearchStart = _this$props5.onSearchStart,
      isInitialMapLoad = _this$props5.isInitialMapLoad,
      setIsInitialMapLoad = _this$props5.setIsInitialMapLoad;
    var searchValue = this.state.searchValue;
    this.setState(function () {
      return {
        searchValue: input,
        searchDisplayValue: input
      };
    }, function () {
      setSearchValue(searchValue);
      if (searchValue.length) onSearchStart();
      _this5.setGeoCoder();
      if (isInitialMapLoad) setIsInitialMapLoad(false);
    });
  };
  _proto.customPlaceSercvce = function customPlaceSercvce(searchValue) {
    var _this6 = this;
    var market = this.props.market;
    var displaySuggestions = function displaySuggestions(predictions) {
      var firstPlace = predictions[0];
      _this6.sendData(firstPlace.description);
    };

    // change the string inside the input property as you wish and get the predicted list stored in a variable
    var service = new this.mapRef.places.AutocompleteService();
    service.getPlacePredictions({
      input: searchValue,
      types: ['(regions)'],
      componentRestrictions: {
        country: _mapNew["default"].replaceLanguageMasters(market)
      }
    }, displaySuggestions);
  };
  _proto.sendForm = function sendForm(event) {
    var searchValue = this.state.searchValue;
    event.preventDefault();
    // this.clearDealers();
    // set searchword state
    var input = this.searchDealersInputField.current;

    // Check whether value is supplied by google suggestion or by direct entry
    if (searchValue === input.value) {
      this.customPlaceSercvce(searchValue);
    } else {
      this.sendData(input.value);
    }
  };
  _proto.showList = function showList() {
    var showList = this.props.showList;
    if (showList) {
      return this.setState({
        showList: true
      });
    }
  };
  _proto.showResetOrSearchIcon = function showResetOrSearchIcon() {
    var input = this.searchDealersInputField.current;
    var searchValue = this.state.searchValue;
    if (searchValue !== '' && input !== null) {
      input.classList.add(_dealerLocator["default"].close);
    } else if (input !== null) {
      input.classList.remove(_dealerLocator["default"].close);
    }
  };
  _proto.clearDealers = function clearDealers() {
    var _this$props6 = this.props,
      updateSelectedDealer = _this$props6.updateSelectedDealer,
      setSearchValue = _this$props6.setSearchValue;
    var input = this.searchDealersInputField.current;
    updateSelectedDealer();
    input.classList.remove(_dealerLocator["default"].close); // bring focus back onto the text box when cleared
    this.setState({
      showList: false,
      searchValue: '',
      searchDisplayValue: ''
    }, function () {
      input.focus();
      setSearchValue(null);
    });
  };
  _proto.toggleTitleVisibility = function toggleTitleVisibility() {
    var _this$props7 = this.props,
      title = _this$props7.title,
      theme = _this$props7.theme,
      noDealersFound = _this$props7.noDealersFound,
      pageData = _this$props7.pageData,
      headingTag = _this$props7.headingTag;
    var showList = this.state.showList;
    return !showList || !noDealersFound ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_commonHeading.CommonHeading, {
      tag: headingTag || 'h1',
      text: title,
      className: _dealerLocator["default"].searchHeader + " " + theme.headingTwo
    }), pageData.description && /*#__PURE__*/_react["default"].createElement("p", {
      className: _dealerLocator["default"].searchDescription + " " + theme.bodyCopy
    }, pageData.description)) : null;
  };
  _proto.renderList = function renderList() {
    var _this$state2 = this.state,
      searchDisplayValue = _this$state2.searchDisplayValue,
      showList = _this$state2.showList;
    var _this$props8 = this.props,
      carServiceCTA = _this$props8.carServiceCTA,
      dealerList = _this$props8.dealerList,
      hoveredDealer = _this$props8.hoveredDealer,
      showRating = _this$props8.showRating,
      testDriveCTA = _this$props8.testDriveCTA,
      theme = _this$props8.theme,
      updateHoveredDealer = _this$props8.updateHoveredDealer,
      updateSelectedDealer = _this$props8.updateSelectedDealer,
      noDealershipFoundMessage = _this$props8.noDealershipFoundMessage,
      updateMobileShowMap = _this$props8.updateMobileShowMap,
      mobileShowMap = _this$props8.mobileShowMap,
      searchResultsFoundLabel = _this$props8.searchResultsFoundLabel,
      market = _this$props8.market,
      listLabel = _this$props8.listLabel,
      mapLabel = _this$props8.mapLabel,
      languageDirection = _this$props8.languageDirection,
      noDealersFound = _this$props8.noDealersFound;
    var numOfDealers = dealerList && dealerList.length > 0 ? dealerList.length : 0;
    if (!noDealersFound && showList) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_searchDealershipsListToggle["default"], {
        mobileShowMap: mobileShowMap,
        theme: theme,
        updateMobileShowMap: updateMobileShowMap,
        listLabel: listLabel,
        mapLabel: mapLabel
      }), /*#__PURE__*/_react["default"].createElement(_searchDealershipsStatusLabel["default"], {
        dealerListLength: numOfDealers,
        searchResultsFoundLabel: searchResultsFoundLabel,
        searchValue: searchDisplayValue || 'Location from get location event',
        noDealershipFoundMessage: noDealershipFoundMessage,
        theme: theme
      }), /*#__PURE__*/_react["default"].createElement(_dealerList["default"], {
        languageDirection: languageDirection,
        carServiceCTA: carServiceCTA,
        dealerList: dealerList,
        hoveredDealer: hoveredDealer,
        mobileShowMap: mobileShowMap,
        showRating: showRating,
        testDriveCTA: testDriveCTA,
        updateHoveredDealer: updateHoveredDealer,
        updateSelectedDealer: updateSelectedDealer,
        theme: theme,
        market: market
      }));
    }
    return null;
  };
  _proto.render = function render() {
    var _clsx, _clsx2;
    var _this$props9 = this.props,
      carServiceCTA = _this$props9.carServiceCTA,
      contactLabel = _this$props9.contactLabel,
      countryCode = _this$props9.countryCode,
      currentLocation = _this$props9.currentLocation,
      locationCtaLabel = _this$props9.locationCtaLabel,
      saleOpeningHoursLabel = _this$props9.saleOpeningHoursLabel,
      salesSearchFilterLabel = _this$props9.salesSearchFilterLabel,
      searchHelpText = _this$props9.searchHelpText,
      selectedDealer = _this$props9.selectedDealer,
      selectedType = _this$props9.selectedType,
      serviceOpeningHoursLabel = _this$props9.serviceOpeningHoursLabel,
      serviceSearchFilterLabel = _this$props9.serviceSearchFilterLabel,
      allDealershipsSearchFilterLabel = _this$props9.allDealershipsSearchFilterLabel,
      showRating = _this$props9.showRating,
      testDriveCTA = _this$props9.testDriveCTA,
      clickShopCTA = _this$props9.clickShopCTA,
      clickshopParamters = _this$props9.clickshopParamters,
      theme = _this$props9.theme,
      updateDealerShipType = _this$props9.updateDealerShipType,
      noGeolocationMessage = _this$props9.noGeolocationMessage,
      noDealershipFoundMessage = _this$props9.noDealershipFoundMessage,
      title = _this$props9.title,
      _this$props9$pageData = _this$props9.pageData,
      getDirectionsLabel = _this$props9$pageData.getDirectionsLabel,
      salesLabel = _this$props9$pageData.salesLabel,
      servicesLabel = _this$props9$pageData.servicesLabel,
      usedCarsSalesLabel = _this$props9$pageData.usedCarsSalesLabel,
      bodyAndPaintLabel = _this$props9$pageData.bodyAndPaintLabel,
      additionalFilters = _this$props9$pageData.additionalFilters,
      languageDirection = _this$props9.languageDirection,
      noDealersFound = _this$props9.noDealersFound,
      searchInventoryLabel = _this$props9.searchInventoryLabel,
      scheduleServiceLabel = _this$props9.scheduleServiceLabel,
      contactUsLabel = _this$props9.contactUsLabel,
      path = _this$props9.path,
      serviceWebsiteCTALabel = _this$props9.serviceWebsiteCTALabel,
      contactSectionOnTop = _this$props9.contactSectionOnTop;
    var _this$state3 = this.state,
      geoCoderError = _this$state3.geoCoderError,
      searchButtonDisabled = _this$state3.searchButtonDisabled,
      searchValue = _this$state3.searchValue;
    var selectFilterContainer = _dealerLocator["default"].selectFilterContainer,
      searchDealers = _dealerLocator["default"].searchDealers,
      searchForm = _dealerLocator["default"].searchForm,
      submitDealers = _dealerLocator["default"].submitDealers,
      clearDealers = _dealerLocator["default"].clearDealers,
      ctaContainer = _dealerLocator["default"].ctaContainer,
      visuallyHidden = _dealerLocator["default"].visuallyHidden,
      locationForm = _dealerLocator["default"].locationForm,
      filterForm = _dealerLocator["default"].filterForm,
      searchFormGroup = _dealerLocator["default"].searchFormGroup;
    var zipCodeFormat = searchValue.replace(/[^0-9.]/g, '');
    var filterOptions = [{
      label: allDealershipsSearchFilterLabel,
      value: 'all'
    }, {
      label: serviceSearchFilterLabel,
      value: 'services'
    }, {
      label: salesSearchFilterLabel,
      value: 'sales'
    }];
    if (selectedDealer) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_dealerDetails["default"], {
        languageDirection: languageDirection,
        carServiceCTA: carServiceCTA,
        clear: this.handleBackButton,
        contactLabel: contactLabel,
        countryCode: countryCode,
        currentLocation: currentLocation,
        dealer: selectedDealer,
        clickShopCTA: clickShopCTA,
        clickshopParamters: clickshopParamters,
        saleOpeningHoursLabel: saleOpeningHoursLabel,
        serviceOpeningHoursLabel: serviceOpeningHoursLabel,
        getDirectionsLabel: getDirectionsLabel,
        showRating: showRating,
        testDriveCTA: testDriveCTA,
        salesLabel: salesLabel,
        servicesLabel: servicesLabel,
        usedCarsSalesLabel: usedCarsSalesLabel,
        bodyAndPaintLabel: bodyAndPaintLabel,
        theme: theme,
        additionalFilters: additionalFilters,
        searchInventoryLabel: searchInventoryLabel,
        scheduleServiceLabel: scheduleServiceLabel,
        contactUsLabel: contactUsLabel,
        path: path,
        zipCode: zipCodeFormat,
        serviceWebsiteCTALabel: serviceWebsiteCTALabel,
        contactSectionOnTop: contactSectionOnTop
      }), /*#__PURE__*/_react["default"].createElement("form", {
        ref: this.searchDealersForm,
        className: searchForm,
        onSubmit: this.sendForm,
        style: {
          visibility: 'hidden'
        },
        tabIndex: "-1"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: searchDealers,
        ref: this.searchDealersInputField,
        type: "text",
        value: searchValue,
        onChange: this.onInputChange,
        autoComplete: "false",
        "aria-label": "Enter your location in this text box to search for Mitsubishi dealerships around you.",
        tabIndex: "-1"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: ctaContainer
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: clearDealers,
        onClick: this.clearDealers,
        type: "reset",
        tabIndex: "-1"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: submitDealers,
        ref: this.searchDealersSubmitButton,
        onClick: this.sendForm,
        tabIndex: "-1"
      }))));
    }
    var isTypeError = function isTypeError(type) {
      return type === 'error';
    };

    // TODO: form needs to be rebuilt so that refs can be passed to the input fields and then broken down to sub components
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.toggleTitleVisibility(), /*#__PURE__*/_react["default"].createElement("div", {
      className: searchFormGroup
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: locationForm
    }, /*#__PURE__*/_react["default"].createElement("form", {
      ref: this.searchDealersForm,
      className: (0, _clsx3["default"])(searchForm, (_clsx = {}, _clsx[_dealerLocator["default"].searchFormCstmMargin] = geoCoderError, _clsx)),
      onSubmit: this.sendForm
    }, /*#__PURE__*/_react["default"].createElement("input", {
      id: searchDealers,
      ref: this.searchDealersInputField,
      type: "text",
      value: searchValue,
      onChange: this.onInputChange,
      autoComplete: "false",
      placeholder: searchHelpText,
      "aria-label": searchHelpText,
      tabIndex: "0"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: ctaContainer
    }, searchValue && /*#__PURE__*/_react["default"].createElement("input", {
      id: clearDealers,
      onClick: this.clearDealers,
      type: "reset",
      tabIndex: "0"
    }), /*#__PURE__*/_react["default"].createElement("input", {
      id: submitDealers,
      ref: this.searchDealersSubmitButton,
      onClick: this.sendForm,
      tabIndex: "0",
      disabled: searchButtonDisabled
    }))), geoCoderError && /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _clsx3["default"])(_dealerLocator["default"].errMsg, _dealerLocator["default"].errMsgMarginCstm)
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: (0, _clsx3["default"])((_clsx2 = {}, _clsx2[theme.mmcIconFormError] = isTypeError('error'), _clsx2))
    }), noGeolocationMessage), /*#__PURE__*/_react["default"].createElement(_searchDealershipsGetLocationButton["default"], {
      theme: theme,
      comp: this,
      getLocation: this.getLocation,
      locationCtaLabel: locationCtaLabel,
      tabIndex: "0"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: filterForm
    }, /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: selectFilterContainer
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "dealerFilter",
      className: visuallyHidden
    }, title), /*#__PURE__*/_react["default"].createElement(_searchDealershipsSelectFilter["default"], {
      handleUpdateDealerShipType: updateDealerShipType,
      selectedType: selectedType,
      name: "dealerFilter",
      filterOptions: additionalFilters ? filterOptions.concat(additionalFilters) : filterOptions,
      theme: theme
    })))), noDealersFound && !geoCoderError && /*#__PURE__*/_react["default"].createElement("p", {
      className: _dealerLocator["default"].errMsg
    }, noDealershipFoundMessage), !noDealersFound && !geoCoderError && this.renderList());
  };
  return SearchDealerships;
}(_react["default"].Component);
SearchDealerships.displayName = 'SearchDealerships';
SearchDealerships.defaultProps = {
  locationCtaLabel: 'Get my location'
};
var _default = SearchDealerships;
exports["default"] = _default;